export const set_otp_service = (payload) => ({
  type: "SET_OTP_SERVICE",
  payload,
});
